/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 10/11/14
 * Time: 3:07 PM
 */

define(function (require) {
    "use strict";

    var PersonalizationController = require("personalization-controllers/PersonalizationController");

    LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        LEPersonalization.addInitializer(function () {
            LEPersonalization.personalizationController = new PersonalizationController();

        });
        LEPersonalization.getMainView = function () {
            return LEPersonalization.personalizationController.getMainView();
        };
        LEPersonalization.navigateToPageMenu = function (options) {
            return LEPersonalization.personalizationController.navigateToPageMenu(options);
        };
        LEPersonalization.navigateToFeatureEdit = function (options) {
            return LEPersonalization.personalizationController.navigateToFeatureEdit(options);
        };
        LEPersonalization.getFeaturesByRoutCount = function (options) {
            return LEPersonalization.personalizationController.getFeaturesByRoutCount(options);
        };

        LEPersonalization.loader={};
        LEPersonalization.loader.setLoader=function () {
            return LEPersonalization.personalizationController.setLoader();
        };
        LEPersonalization.loader.closeLoader=function () {
            return LEPersonalization.personalizationController.closeLoader();
        };


    });

    return LE.module("LEPersonalization");
});
